import { render } from "./TableResponsive.vue?vue&type=template&id=741f924a&scoped=true"
import script from "./TableResponsive.vue?vue&type=script&lang=js"
export * from "./TableResponsive.vue?vue&type=script&lang=js"

import "./TableResponsive.vue?vue&type=style&index=0&id=741f924a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-741f924a"]])

export default __exports__